define('home/models/ExploreViewModel',[
    'backbone',

    'core/api',
    'core/collections/ChannelCollection',

    'home/models/Feed',
    'home/collections/PaginatedUserCollection',
], function (
    Backbone,

    api,
    ChannelCollection,

    Feed,
    PaginatedUserCollection
) {
    'use strict';

    var ExploreViewModel = Backbone.Model.extend({
        initialize: function () {
            this.exploreChannelCollection = new ChannelCollection([], {
                listName: 'explore',
            });

            this.allStars = new Feed({}, {
                collectionClass: PaginatedUserCollection,
                collectionUrl: api.getURL('internal/users/listPowerContributors'),
            });
        },
    });

    return ExploreViewModel;
});

